import { apiFetch } from '../lib/api';
import type { FishTypeResponse } from '../types/api';

export function listFishTypes(): Promise<FishTypeResponse[]> {
  return apiFetch<FishTypeResponse[]>('/api/fishtypes');
}
